<template>
  <v-card style="text-align: center">
    <h2>Pilih Bulan & Tahun Laporan</h2>
    <br />
    <v-row>
      <v-col cols="6">
        <div style="text-align: center">
          <b>BULAN 1</b>
        </div>
        <br />
        <v-row justify="center">
          <v-date-picker v-model="rugiLaba.from" type="month" />
          <br />
        </v-row>
      </v-col>
      <v-col cols="6">
        <div style="text-align: center">
          <b>BULAN 2</b>
        </div>
        <br />
        <v-row justify="center">
          <v-date-picker v-model="rugiLaba.to" type="month" />
          <br />
        </v-row>
      </v-col>
    </v-row>
    <br />
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" variant="text" @click="onclose"> Batal </v-btn>
      <v-btn
        color="primary"
        variant="text"
        @click="
          () => {
            onclose();
            generateRugiLaba();
          }
        "
      >
        Generate Laporan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ModalContentLabaRugi',
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    let period = this.$getSelectedMonthYear();
    this.periode = period.dateTime;
    this.rugiLaba.from = period.dateTimePrev;
    this.rugiLaba.to = period.dateTime;
  },
  data() {
    return {
      periode: '',
      rugiLaba: {
        from: '',
        to: '',
      },
    };
  },
  methods: {
    generateRugiLaba() {
      this.$router.push(`/laporan/gl/rugiLaba?from=${this.rugiLaba.from}&to=${this.rugiLaba.to}`);
    },
  },
};
</script>
